import { formatTimeForID3Tag } from '@/helpers/date-formatter'

// Raw ID3Tag data from the stream
export interface ID3Tag {
  series_title?: string
  ww?: string
  ioi?: string
  scode?: string
  pcode?: string
  prog_genre?: string
  title?: string
  material_id?: string
  start_date_time?: string
  full_dur_frames?: string
  ref_date?: string
  episode_number?: string
  series_number?: string
}

// Processed ID3Tag with parsed dates
export interface NielsenID3Tag extends ID3Tag {
  startDate?: Date           // Parsed from start_date_time
  tagCreationDate?: Date     // Parsed from ref_date
}

/**
 * Parses raw ID3Tag data and returns a properly typed ID3Tag with parsed dates
 * @param raw - Raw ID3Tag data from the stream
 * @returns Processed ID3Tag with parsed date fields
 */
export function parseID3TagForNielsen(raw: ID3Tag): NielsenID3Tag {
  return {
    ...raw,
    startDate: formatTimeForID3Tag(raw.start_date_time),
    tagCreationDate: formatTimeForID3Tag(raw.ref_date)
  }
}

export function areID3TagsDifferent(current: ID3Tag | undefined, newTag: ID3Tag): boolean {
  return newTag.pcode !== current?.pcode
}

export function formattedTitleForTag(id3Tag: ID3Tag): string {
  let titleVal: string | undefined = undefined
  if (id3Tag.series_title) {
      if (id3Tag.series_title && id3Tag.series_title.toLowerCase() !== "none"){
          titleVal = id3Tag.series_title?.slice(0, 90)
      }
  }
  
  let seriesAndEpisodeNum: string | undefined = undefined
  if (id3Tag.series_number && id3Tag.episode_number && id3Tag.series_number.toLowerCase() !== "none" && id3Tag.episode_number.toLowerCase() !== "none") {
    seriesAndEpisodeNum = `S${id3Tag.series_number}-E${id3Tag.episode_number}`
  } else if (id3Tag.series_number && id3Tag.series_number.toLowerCase() !== "none") {
    seriesAndEpisodeNum = `S${id3Tag.series_number}`
  } else if (id3Tag.episode_number && id3Tag.episode_number.toLowerCase() !== "none") {
    seriesAndEpisodeNum = `E${id3Tag.episode_number}`
  }


  if (seriesAndEpisodeNum){ 
    if (!titleVal) {
      titleVal = seriesAndEpisodeNum
    } else {
      titleVal = titleVal + ` ${seriesAndEpisodeNum}`
    }
  }
  return titleVal || ""
}

export function assetIdForTag(id3Tag: ID3Tag): string {
  let assetId: string
  if (id3Tag.material_id && id3Tag.material_id.toLocaleLowerCase() !== "none") {
    assetId = id3Tag.material_id
  } else {
    assetId = id3Tag.pcode || ""
  }
  return assetId
}